import axios from "axios";
// import router from "../../router";
// import firebase from "firebase";
export default {
  namespace: true,
  state: {
    token: [],
    code: "",
    session: false,
    log: ""
  },
  actions: {
    requestToken({ state, commit }) {
      axios({
        method: "post",
        url: "http://localhost:5000/inedita-852a9/us-central1/authentication",
        headers: {
          Accept: "application/json"
        },
        data: {
          code: state.code
        }
      })
        .then(response => {
          // eslint-disable-next-line no-console
          if (!response.data["name"]) {
            commit("insertToken", response.data);
            commit("insertSession", true);
            localStorage.setItem("token", JSON.stringify(response.data));
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log("Esto es un error" + err);
        });
      //await dispatch("loginFirebase")
    }
  },
  mutations: {
    insertCode: (state, code) => {
      state.code = code;
    },
    insertToken: (state, token) => {
      // eslint-disable-next-line no-console
      state.token = token;
    },
    insertSession: (state, session) => {
      state.session = session;
    }
  },
  getters: {
    getSession: state => {
      return state.session;
    },
    getToken: state => {
      // eslint-disable-next-line no-console
      return state.token;
    },
    getCode: state => {
      return state.code;
    }
  }
};
